import React from 'react';

const AuthLayout = (WraperContent) => {
  return function () {
    return (
      <>
        <div className="login-page">
          {/* Header Section */}
          <header className="login-header">
            <img className="logo"
              src={require('../../../static/img/Multiverse_logo.png')}
              alt="Multivrse Logo"
            />
          </header>

          {/* Main Content Section */}
          <div className="login-main">
            {/* Left Section (Image) */}
            <div className="login-image">
              <img
                src={require('../../../static/img/newImages/banner.jpg')}
                alt="World Map"
                className="world-map-image"
              />
              <div className="tagline">Closer Customers. Stronger Growth</div>
            </div>

            {/* Right Section (Form) */}
            <div className="login-form-section">
              <WraperContent />
            </div>
          </div>
          {/* 
          <header className="login-Footer">
            <img className="logo_footer"
              src={require('../../../static/img/Multiverse_logo.png')}
              alt="Multivrse Logo"
            />
          </header> */}
        </div>
      </>
    );
  };
};

export default AuthLayout;
